/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Exposure USD bucket labels for filtering.
 * Definition: (Label, Min Value, Max Value). .value is the label for API/URL compatibility.
 * @export
 */
export const ControlZeroDayAlertExposureUsdRange = {
    _10M: '10M',
    _5M: '5M',
    _1M: '1M',
    _500K: '500K',
    _100K: '100K',
    _50K: '50K',
    _10K: '10K',
    _0: '0'
} as const;
export type ControlZeroDayAlertExposureUsdRange = typeof ControlZeroDayAlertExposureUsdRange[keyof typeof ControlZeroDayAlertExposureUsdRange];


export function ControlZeroDayAlertExposureUsdRangeFromJSON(json: any): ControlZeroDayAlertExposureUsdRange {
    return ControlZeroDayAlertExposureUsdRangeFromJSONTyped(json, false);
}

export function ControlZeroDayAlertExposureUsdRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlZeroDayAlertExposureUsdRange {
    return json as ControlZeroDayAlertExposureUsdRange;
}

export function ControlZeroDayAlertExposureUsdRangeToJSON(value?: ControlZeroDayAlertExposureUsdRange | null): any {
    return value as any;
}

